angular
  .module('capability-ng-reports')
  .config(($stateProvider: ng.ui.IStateProvider, $urlRouterProvider: ng.ui.IUrlRouterProvider) => {
    const Routes = {
      'my.reports': {
        url: 'reports',
        fullPath: '/my/reports',
        template: `<summary-ng-hil-component title="Docs" uri="ahp/reports/views/reports.hil"></summary-ng-hil-component>`,
        data: {
          viewTitle: 'Docs',
          ignoredInHistory: false,
          hasMainMenu: true
        }
      },
      'my.appointmentSummary': {
        url: 'appointment-summary',
        fullPath: '/my/appointment-summary',
        template: `<summary-ng-hil-component title="Appointment Summary" uri="ahp/reports/views/appt_summary/appt_summary.hil"></summary-ng-hil-component>`,
        data: {
          viewTitle: 'Appointment Summaries',
          ignoredInHistory: false
        }
      },
      'my.appointmentSummary-details': {
        url: 'appointment-summary-details/?id',
        fullPath: '/my/appointment-summary-details/?id',
        template: `<summary-ng-hil-component uri="ahp/reports/views/appt_summary/details.hil"></summary-ng-hil-component>`,
        data: {
          viewTitle: 'Appointment Summary Detail',
          ignoredInHistory: false
        }
      },
      'my.notes': {
        url: 'notes',
        fullPath: '/my/notes',
        template: `<summary-ng-hil-component uri="ahp/reports/views/notes/notes.hil"></summary-ng-hil-component>`,
        data: {
          viewTitle: 'Notes',
          ignoredInHistory: false
        }
      },
      'my.notes-details': {
        url: 'notes-details/?id',
        fullPath: '/my/notes-details/?id',
        template: `<summary-ng-hil-component uri="ahp/reports/views/notes/details.hil"></summary-ng-hil-component>`,
        data: {
          viewTitle: 'Notes Detail',
          ignoredInHistory: false
        }
      },
      'my.progressReport': {
        url: 'progress-report',
        fullPath: '/my/progress-report',
        template: `<summary-ng-hil-component uri="ahp/reports/views/progress_report/progress_report.hil"></summary-ng-hil-component>`,
        data: {
          viewTitle: 'Progress Reports',
          ignoredInHistory: false
        }
      },
      'my.progressReport-details': {
        url: 'progress-report-details/?id',
        fullPath: '/my/progress-report-details/?id',
        template: `<summary-ng-hil-component uri="ahp/reports/views/progress_report/details.hil">
        </summary-ng-hil-component>
        `,
        data: {
          viewTitle: 'Progress Report Detail',
          ignoredInHistory: false
        }
      },
      'my.selfAlerts': {
        url: 'self-alerts',
        fullPath: '/my/self-alerts',
        template: `<summary-ng-hil-component uri="ahp/reports/views/self_alerts/self_alerts.hil"></summary-ng-hil-component>`,
        data: {
          viewTitle: 'Self Alerts',
          ignoredInHistory: false
        }
      },
      'my.selfAlerts-details': {
        url: 'self-alerts/?id',
        fullPath: '/my/self-alerts-details/?id',
        template: `<summary-ng-hil-component uri="ahp/reports/views/self_alerts/details.hil">
        </summary-ng-hil-component>
        `,
        data: {
          viewTitle: 'Self Alerts Detail',
          ignoredInHistory: false
        }
      }
    };
    for (const stateName in Routes) {
      $stateProvider.state(stateName, Routes[stateName]);
      const stateObject = Routes[stateName];
      const fullURL = stateObject.fullPath;
      $urlRouterProvider.when(
        fullURL,
        ($match: any, $stateParams: ng.ui.IStateParamsService, $state: ng.ui.IStateService) => {
          if ($match) {
            $state.go(stateName, { ...$match }, { location: false });
          } else {
            $state.go(stateName, { location: false });
          }
        }
      );
    }
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-reports/src/routes.ts